import { render } from "./TestingTab.vue?vue&type=template&id=738803fa"
import script from "./TestingTab.vue?vue&type=script&lang=js"
export * from "./TestingTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__